/*!
 * React Native Globalize
 *
 * Copyright 2015-2020 Josh Swan
 * Released under the MIT license
 * https://github.com/joshswan/react-native-globalize/blob/master/LICENSE
 */
import React, { useContext } from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { GlobalizeContext } from '../context';
export const withGlobalize = (Component) => hoistStatics((props) => {
    const globalize = useContext(GlobalizeContext);
    return React.createElement(Component, Object.assign({}, props, { globalize: globalize }));
}, Component);
